module.exports = __webpack_public_path__ + "static/media/METIS.11931ddb.svg";